var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 42C6.89543 42 6 41.1046 6 40V8C6 6.89543 6.89543 6 8 6H40C41.1046 6 42 6.89543 42 8V40C42 41.1046 41.1046 42 40 42H8Z",
    fill: "#F7DF1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.538 32.947C30.23 34.071 30.982 35.148 32.575 35.148C33.913 35.148 34.615 34.483 34.615 33.563C34.615 32.462 33.889 32.071 32.417 31.43L31.61 31.086C29.281 30.098 27.732 28.86 27.732 26.245C27.732 23.835 29.577 22.001 32.46 22.001C34.513 22.001 35.988 22.712 37.052 24.574L34.538 26.181C33.985 25.193 33.387 24.804 32.46 24.804C31.514 24.804 30.915 25.401 30.915 26.181C30.915 27.145 31.515 27.535 32.9 28.132L33.707 28.476C36.452 29.645 38 30.839 38 33.523C38 36.415 35.716 38 32.65 38C29.651 38 27.948 36.495 27 34.632L29.538 32.947ZM17.952 33.029C18.458 33.935 19.227 34.632 20.333 34.632C21.391 34.632 22 34.214 22 32.589V22H25.333V33.101C25.333 36.468 23.38 38 20.528 38C17.951 38 16.091 36.254 15.333 34.632L17.952 33.029Z",
    fill: "#000001"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.1a987ea389c931b550cb2e56429e9190.svg";
export { ForwardRef as ReactComponent };